<template>
  <div class="complete_content">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div class="content">
          <div class="title">
            <h2>仮登録完了</h2>
          </div>
          <div class="user_regist_thanks">
            <p>
              仮登録いただきありがとうございます。<br>
              ご入力いただいたアカウントはまだ本登録が完了しておりません。<br>
              引き続き、ご案内メールより本登録を行ってください。
            </p>
            <p>
              ※受信制限をされている方は、「<span class="pickup">@domans.co.jp</span>」からのメールを受信許可に設定してください<br>
              ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。
            </p>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import LoginForm from '../components/login/DcLoginForm'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-menu': DDLeftMenu,
    'dd-login': LoginForm
  },
  data () {
    return {
    }
  }
}
</script>
<style src="../css/dc-login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSendMailComplete.vue